import BrandingFeatures from '@propertypal/web-ui/src/products/BrandingFeatures';
import ProductsContact from '@propertypal/web-ui/src/products/ProductsContact';
import Head from 'next/head';
import React from 'react';
import generateMetaTags from '../../../components/layout/MetaTags';

const metaData = {
  title: 'Branding - PropertyPal',
  description: 'Full Service Solution For Marketing Your Business.',
  url: `/products/estate-agents/branding`,
};

const AgentsBranding = () => {
  return (
    <>
      <Head>{generateMetaTags(metaData)}</Head>

      <BrandingFeatures />
      <ProductsContact reason="Estate Agents Branding" />
    </>
  );
};

export default AgentsBranding;
